export default "__VITE_ASSET__CkGVogas__"